export var CharacterLimit;
(function (CharacterLimit) {
    CharacterLimit[CharacterLimit["BUG_REPORT"] = 1000] = "BUG_REPORT";
    CharacterLimit[CharacterLimit["HELP_REQUEST"] = 1000] = "HELP_REQUEST";
    CharacterLimit[CharacterLimit["HEADER"] = 100] = "HEADER";
    CharacterLimit[CharacterLimit["FILE_NAME"] = 255] = "FILE_NAME";
    CharacterLimit[CharacterLimit["TAGS_LENGTH"] = 24] = "TAGS_LENGTH";
    CharacterLimit[CharacterLimit["TAGS_COUNT"] = 16] = "TAGS_COUNT";
})(CharacterLimit || (CharacterLimit = {}));
